import { css } from '@emotion/react'
import { memo } from 'react'
import { openTokensDrawer } from '../../../../app-state/modals/state.drawer'
import i18n from '../../../../utilities/i18n'
import { palette } from '../../../styles/colors'
import { PAPER_HEIGHTS } from '../../../theme'

const tokenSpanStyles = css({
    position: 'absolute',
    top: 'calc(env(safe-area-inset-top, 0px) * 0.7)',
    left: 'calc(env(safe-area-inset-left, 0px) * 0.7)',
    padding: 8,
    paddingBottom: 4,
    textDecoration: 'none',
    color: palette.commonWhite,
    fontSize: 13,
    zIndex: PAPER_HEIGHTS.floatingActionBar,
    cursor: 'pointer',
    '&:hover': {
        textDecoration: 'underline',
    },
})

const onPurchaseTokens = () => openTokensDrawer()

interface TokenCountProps {
    tokens: number
    pm?: boolean
}

const TokenCount = memo<TokenCountProps>(({ tokens, pm }) => (
    <span
        css={[
            tokenSpanStyles,
            {
                paddingLeft: !pm ? 12 : 8,
                ...(pm
                    ? {
                          background: 'rgba(0, 0, 0, 0.6)',
                          borderRadius: '0 0 4px 0',
                      }
                    : { filter: palette.overlayFilterDropShadow }),
            },
        ]}
        data-testid="Chat__TokensCount"
        onClick={onPurchaseTokens}
        title={i18n.t('header.purchaseTokens')}
    >
        {tokens ?? ''} {i18n.t('header.tokens')}
    </span>
))

export default TokenCount
